import React from 'react'
import { useState, useEffect } from 'react'
import Tabs from '../../../../Components/Tabs'
import { Link, useNavigate } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'
import Tab4 from './Tab4'
import Table from './Table'
import GetIcon from '../../../../utils/Icon'
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"
import { useGetDeliveryNoteDocQuery, useCreateDeliveryNotePicklistMutation, useSubmitDeliveryNoteMutation } from '../../../../store/api/deliveryNoteApi'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import { usePostCreatePackingSlipMutation } from '../../../../store/api/packingSlip'

import { useGetPicklistDetailsQuery } from '../../../../store/api/picklist'
import Tab5 from './Tab5'
import Attachment from '../../../../utils/Attachment'

function Deliverynote({ deliveryNoteId }) {
    // function Deliverynote() {





    const nvg = useNavigate()
    const [buttonData, setButtonData] = useState(false)
    const [errorr, setError] = useState('');
    const [ptype, setptype] = useState("Error ")
    const [showError, setShowError] = useState(false);
    const [submitboll, setsubmitboll] = useState(false)

    const [tab, settab] = useState(1)
    const [showDropdown, setShowDropdown] = useState(false);
    const handleNavigate = (path) => {
        nvg(path);
        setShowDropdown(false);
    };
    const toggleDropdown = () => {
        setShowDropdown(prev => !prev);
    };


    const [deliveryNoteData, setDeliveryNoteData] = useState(null);
    const [deliveryNoteItems, setDeliveryNoteItems] = useState([]);
    const [packedCompleted, setPackedCompleted] = useState(false);
    const [shipmentItems, setshipmentItems] = useState([]);

    const idFromLocalStorage = localStorage.getItem("deliveryNoteId");
    const idToUse = deliveryNoteId || idFromLocalStorage;
    const [activityboll, setactivityboll] = useState(false)

    const {
        data: deliveryNoteResponse,
        isLoading,
        isError,
        error
    } = useGetDeliveryNoteDocQuery(idToUse);


    useEffect(() => {
        if (deliveryNoteResponse?.docs?.[0]) {
            const fullDoc = deliveryNoteResponse.docs[0];
            const { items, ...rest } = fullDoc;
            // console.log(fullDoc.custom_shipment_references,"fullDoc_check");
            setshipmentItems(fullDoc.custom_shipment_references || [])
            setDeliveryNoteItems(items || []);
            setDeliveryNoteData(rest);
            
            // console.log(rest,"REST DATA")
            const allPacked = items?.every(
                item => Number(item.qty) === Number(item.packed_qty)
            );

            setPackedCompleted(allPacked);

        }

        if (isError) {
            alert(error)
        }
    }, [deliveryNoteResponse, isError, error]);





    const handlePackSlipClick = async () => {
        console.log(deliveryNoteId, "deliveryNoteId");


        if (!deliveryNoteId) {
            console.error("No delivery note ID available");
            return;
        }

        // Set deliveryNoteId in localStorage
        localStorage.setItem("deliveryNoteId", deliveryNoteId);

        // Navigate with the deliveryNoteId in state
        nvg("/outbound/outbound-create-packingslip", {
            state: { deliveryNoteId: deliveryNoteId }
        });
    };

    const [submitDeliveryNote, { datanew, isLoadingtwo, isSuccess, errortwo }] = useSubmitDeliveryNoteMutation();

    const handleSubmit = async () => {
        const idFromLocalStorage = localStorage.getItem("deliveryNoteId");
        const idToSubmit = deliveryNoteId || idFromLocalStorage;

        if (!idToSubmit) {
            console.error("❌ No delivery note ID found.");
            return;
        }

        try {
            const result = await submitDeliveryNote(idToSubmit).unwrap();
            setError('Submited');
            setptype('Delivery Note submitted successfully:');
            setShowError(true);
            setsubmitboll(true)
            setactivityboll(prev => !prev);

            if (!deliveryNoteId && idFromLocalStorage) {
                localStorage.removeItem("deliveryNoteId");
            }
        } catch (err) {
            console.error('❌ Failed to submit Delivery Note:', err);
        }
    };



    const handleCreateSalesInvoice = () => {
        if (deliveryNoteId) {
            nvg("/outbound/outbound/create-sales-invoice/", {
                state: { deliveryNoteId },
            });
        } else {
            console.error("No deliveryNoteId to send.");
        }
    };

    const handleCreateSalesReturn = () => {
        if (deliveryNoteId) {
            nvg("/outbound/sales-return/", {
                state: { deliveryNoteId },
            });
        } else {
            console.error(" No deliveryNoteId to send.");
        }
    };
    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0"> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/outbound-delivery-note')}>Delivery Note List </p>
                    {/* /outbound/outbound-delivery-note */}
                    <p className="m-0">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        New Delivery Note View
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >

                            {deliveryNoteData?.status}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px', flexGrow: '1' }} >

                    {!submitboll && deliveryNoteData?.status === 'Draft' && !packedCompleted && (
                        <Button
                            style={{ gap: '2px', background: '#391F84' }}
                            // className="mb-0 align-items-center custom-btn-00989blue"
                            className="custom-btn-blue852"
                            iconName="FaPlus"
                            iconSize={14}
                            onClick={handlePackSlipClick}
                        >
                            Packing Slip
                        </Button>
                    )}
                    {/* <Button
                        style={{ gap: '2px' }}
                        className="createbtn"
                        iconName="GrCopy"
                        iconSize={12}
                    >
                        Duplicate
                    </Button> */}
                    {deliveryNoteData?.status == 'To Bill' || submitboll ? <Button
                        style={{ gap: '2px' }}
                        className="createbtn"
                        iconName="FaPlus"
                        iconSize={12}
                        onClick={handleCreateSalesInvoice}
                    >
                        Create Sales Invoice
                    </Button> : ''}


                    {deliveryNoteData?.status === 'Draft' && !submitboll && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                    )}

                    {deliveryNoteData?.is_return === 0 && deliveryNoteData?.docstatus === 1 &&
                        deliveryNoteData?.status !== 'Closed' && deliveryNoteData?.status !== 'Return Issued' ? (
                            <Button
                                style={{ gap: '2px' }}
                                className="custom-btn-00989"
                                iconName="LuFilePlus2"
                                iconSize={12}
                                onClick={handleCreateSalesReturn}
                            >
                                Sales Return
                            </Button>
                        ) : ''}
  

                </div>
            </div>
            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                            <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                                <a className={tab == 2 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                                    Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                            <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                                <a className={tab == 3 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(3) }} href="javascript:void(0);">
                                    Shipment {tab == 3 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>

                        </ul>
                        <Attachment doctype="Delivery Note" docname={deliveryNoteId} />
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1 deliveryNoteData={deliveryNoteData} activityboll={activityboll} />
                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex" style={{ gap: '5px' }}>
                            <p className="orangebtn">No. of lines - <span style={{ color: '#2563EB' }}>{deliveryNoteItems?.length}</span></p>
                            <p className="pinkbutton">Total Quantity -  <span style={{ color: '#16A34A' }}>{deliveryNoteData?.total_qty}</span></p>
                            <p className="greenbtn">pick quantity-  <span style={{ color: '#fd8c5c' }}> {deliveryNoteData?.total_qty}</span></p>
                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500' }}>
                                Item Details
                            </p>
                        </div>
                        <Table deliveryNoteItems={deliveryNoteItems} />
                    </div>
                    <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px' }}> <Tab2 deliveryNoteData={deliveryNoteData} /> </div>
                    <div className="col-12" style={{ visibility: tab == 3 ? "visible" : 'hidden', height: tab == 3 ? "auto" : '0px' }}> <Tab5 deliveryNoteData={deliveryNoteData} deliveryNoteItems={shipmentItems} /> </div>
                    <div className="col-12" style={{ visibility: tab == 4 ? "visible" : 'hidden', height: tab == 4 ? "auto" : '0px' }}> <Tab4 /> </div>
                </div>
            </div>

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={errorr}
                onClose={() => setShowError(false)}
            />

        </>
    )
}

export default Deliverynote
